module.exports = __webpack_public_path__ + "img/a205667248e478bdf75b164ce0ea13f9.svg";